$open-background-pinch-amount: 14px;

.dialog {
  --ixf-dialog-padding-horizontal: var(--ixf-space-4);
  --ixf-dialog-padding-vertical: var(--ixf-space-4);

  &:focus-visible,
  &:focus,
  &:focus-within {
    outline: none;
  }
}

.pinchedContent {
  :global(#root) {
    @media (prefers-reduced-motion: no-preference) {
      width: calc(100dvw - (#{$open-background-pinch-amount} * 2));
      height: calc(100dvh - (#{$open-background-pinch-amount} * 2));
      margin: $open-background-pinch-amount;
      border-radius: var(--ixf-border-radius-2);
    }
  }
}
